export default API => ({
    //活动列表
    activeList() {
        return API({
            url: `/gsyf/v1/study/get_hot_activity`,
            method:'get'
        })
    },
    // 立即参与
    joinActivity(params) {
        return API({
            url: `/gsyf/v1/study/join_activity`,
            params,
            method:'post'
        })
    },
    // 上课签到
    startSign(params) {
        return API({
            url: `/gsyf/v1/study/start_sign`,
            params,
            method:'post'
        })
    },
    // 下课签到
    endSign(params) {
        return API({
            url: `/gsyf/v1/study/end_sign`,
            params,
            method:'post'
        })
    },
})
  